/**
 * Shell classes shared by the sidebar-style search fields (the agent dock's
 * search pill, the takeover nav's search field). At rest the field is a
 * plain rounded hairline with no fill — the `input` field-border token, not
 * the divider token, so it reads as a control edge rather than one more
 * rule. Hover tints the hairline toward the accent, and focus trades it for
 * a full accent border plus a soft ring halo, so the active field clearly
 * stands apart from the dividers around it. Hover is gated with
 * `not-focus-within:` because Tailwind orders the `focus-within` variant
 * before `hover`, which would otherwise let the hover border override the
 * focus border.
 */
export const searchFieldShellClasses = [
  'rounded-lg border border-input bg-transparent',
  'transition-[border-color,box-shadow] duration-200',
  'not-focus-within:hover:border-ring/40',
  'focus-within:border-ring/70 focus-within:ring-[3px] focus-within:ring-ring/20',
].join(' ');
